exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-toggler-icon {\r\n  background-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22utf-8%22%3F%3E%0D%3C!-- Generator%3A Adobe Illustrator 21.1.0%2C SVG Export Plug-In . SVG Version%3A 6.00 Build 0)  --%3E%0D%3Csvg version%3D%221.1%22 id%3D%22Warstwa_1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 x%3D%220px%22 y%3D%220px%22%0D%09 viewBox%3D%220 0 27 21%22 style%3D%22enable-background%3Anew 0 0 27 21%3B%22 xml%3Aspace%3D%22preserve%22%3E%0D%3Cstyle type%3D%22text%2Fcss%22%3E%0D%09.st0%7Bfill%3A%233B00F2%3B%7D%0D%3C%2Fstyle%3E%0D%3Crect class%3D%22st0%22 width%3D%2227%22 height%3D%223%22%2F%3E%0D%3Crect y%3D%229%22 class%3D%22st0%22 width%3D%2227%22 height%3D%223%22%2F%3E%0D%3Crect y%3D%2218%22 class%3D%22st0%22 width%3D%2227%22 height%3D%223%22%2F%3E%0D%3C%2Fsvg%3E%0D\");\r\n}\r\n\r\n.hamburger {\r\n  border-color: transparent;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/header/header.component.css
// module id = ../../../../../src/app/header/header.component.css
// module chunks = main